export default __webpack_public_path__ + "static/media/cern-regular.a90d62fc.ttf";